export default "__VITE_ASSET__CiLNGVWm__"